const { OrganisationList } = require("pages/Organisations/List");
const { LanguageEdit } = require("./Language/Edit");

export ModuleList from "./Modules/List";
export ModuleEdit from "./Modules/Edit";
export AppList from "./Applications/List";
export AppEdit from "./Applications/Edit";
export LanguageList from "./Language/List";
export LanguageEdit from "./Language/Edit";
export PromocodeList from "./Promocode/List";
export PromocodeEdit from "./Promocode/Edit";
export CompanyList from "./Company/List";
export CompanyEdit from "./Company/Edit";
export CompanyDetail from "./Company/Detail";
export OrganisationList from "./Organisation/List";
export OrganisationDetail from "./Organisation/Detail";
export InvoiceView from "./Invoice/View";

export HesaabEmployeeList from "./Employee/List";
export HesaabEmployeeEdit from "./Employee/Edit";

